
import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import {IPlan, IPlanRes } from './index.type';

const useFetchPatient = () => {
  const [plans, setPlans] = React.useState<IPlan[]>();
  const { loading:planLoading, makeApiCall } = useApi({
    // url: `/RTM/getAllActivePlans`,
    url: `/rtm/plan/active`,
    method: 'GET',
  });

  const getPlans = async () => {
    const { response, error } = await makeApiCall<undefined, IPlanRes>();
    if (response?.status) {
        setPlans(response?.allplans);
    }

    if (!response?.status) {
        setPlans(undefined);
    }

    if (error) toast.error(error.msg || 'Something went wrong while fetching plan. Please try again later');
  };

  return {
    plans,
    getPlans,
    planLoading,
  };
};

export default useFetchPatient;
